/*
 * @Author: mina.min
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-06-21 18:23:34
 * @FilePath: /OTAManagementSystem/src/store/deviceStore.ts
 * @Description: 设备管理数据存储
 */

import { deleteDevice, getDeviceList, type Device } from '@/services/device'
import { makeAutoObservable } from 'mobx'

export type { Device } from '@/services/device'

class DeviceStore {
  deviceList: Device[] = []
  loading = false
  pagination = { current: 1, pageSize: 50, total: 0 }

  constructor() {
    makeAutoObservable(this)
  }

  async fetchDeviceList(pageNum = '1', pageSize = '50') {
    this.loading = true
    try {
      const res = await getDeviceList({ pageNum, pageSize })
      this.deviceList = res.data.list
      this.pagination = {
        current: Number(res.data.pageNum),
        pageSize: Number(res.data.pageSize),
        total: Number(res.data.total),
      }
    } catch (error) {
      throw error
    } finally {
      this.loading = false
    }
  }

  async removeDevice(vehicleId: string) {
    this.loading = true
    try {
      const res = await deleteDevice({ vehicleId })
      if (res.code === '200') {
        await this.fetchDeviceList(
          String(this.pagination.current),
          String(this.pagination.pageSize)
        )
      }
      return res
    } catch (error) {
      throw error
    } finally {
      this.loading = false
    }
  }
}

export const deviceStore = new DeviceStore()
